import { memo, useMemo } from 'react';
import { useSearchParams } from 'react-router-dom';
import dayjs from 'dayjs';
import { Button, CheckIcon } from '@quickmd-llc/design-system';
import { useFilters } from '../useFilters';

interface Props {
  children: React.ReactNode;
  onClick: (hour: number) => void;
  value: number;
}

function HourButton({ children, value, onClick }: Props): JSX.Element {
  const { hour } = useFilters();
  const [searchParams] = useSearchParams();
  const date = searchParams.get('date');
  const isSelected = value === hour;
  const isDisabled = useMemo(() => {
    const d = dayjs(date).hour(value + 1);
    const now = dayjs();

    return d.isBefore(now);
  }, [date, value]);

  function handleClick() {
    onClick(value);
  }

  return (
    <Button
      disabled={isDisabled}
      onClick={handleClick}
      priority={isSelected ? 'primary' : 'secondary'}
      size="s"
    >
      {isSelected && <CheckIcon iconSize="l" />}
      {children}
    </Button>
  );
}

export default memo(HourButton);
